export const copy = {
  onboarding: {
    welcome: '준비 중인 시험을 알려주세요. 회원가입 없이 바로 시작해요.',
  },
  log: {
    prompt: '오늘 공부를 기록하면 회독이 쌓여요.',
  },
  wrongNote: {
    empty: '틀린 문제를 남기면 시험 전에 내 오답만 다시 볼 수 있어요.',
  },
  state: {
    loadingTitle: '차분히 준비하고 있어요',
    loadingDescription: '기기에 저장된 기록을 확인하는 중이에요.',
    emptyFilteredTitle: '조건에 맞는 기록이 없어요',
    emptyFilteredDescription: '필터를 지우면 전체 기록을 다시 볼 수 있어요.',
    partialTitle: '일부 연결 기능을 불러오지 못했어요',
    partialDescription: '기기에 저장된 기록은 그대로 사용할 수 있어요.',
    offlineTitle: '연결 없이 사용할 수 있는 기능을 보여드려요',
    offlineDescription: '기록은 계속 남길 수 있고, 연결이 돌아오면 필요한 작업을 이어가요.',
    recoverableTitle: '이 작업을 마치지 못했어요',
    terminalTitle: '지금은 이 기능을 사용할 수 없어요',
    destructiveTitle: '변경할 내용을 확인해 주세요',
  },
} as const;
